/* VDPS detail carousel.

   Replaces the reference's Embla instance. The browser does the scrolling and
   the snapping; this only reflects the current slide in the dots, the arrows
   and the counter, and moves the viewport when a control is used.

   Progressive enhancement: the controls stay hidden by CSS until this script
   marks the carousel ready, so a JS failure leaves a working horizontal
   scroller rather than dead buttons. */
(function () {
  var root = document.querySelector('[data-vdps-carousel]');
  if (!root) return;

  var viewport = root.querySelector('.vr-vdps-carousel-viewport');
  var slides = Array.prototype.slice.call(
    root.querySelectorAll('.vr-vdps-carousel-slide')
  );
  var dots = Array.prototype.slice.call(
    root.querySelectorAll('.vr-vdps-carousel-dots button')
  );
  var prev = root.querySelector('[data-vdps-carousel-prev]');
  var next = root.querySelector('[data-vdps-carousel-next]');
  var current = root.querySelector('[data-vdps-carousel-current]');

  if (!viewport || slides.length === 0) return;

  root.classList.add('vdps-carousel-ready');

  var index = 0;

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  // The nearest slide to the current scroll position is the selected one.
  // Comparing offsets rather than tracking scroll events keeps this correct
  // after a resize, a font swap or an image loading late.
  function nearestIndex() {
    var x = viewport.scrollLeft;
    var best = 0;
    var bestDistance = Infinity;

    for (var i = 0; i < slides.length; i++) {
      var distance = Math.abs(slides[i].offsetLeft - viewport.offsetLeft - x);
      if (distance < bestDistance) {
        bestDistance = distance;
        best = i;
      }
    }
    return best;
  }

  function render() {
    for (var i = 0; i < dots.length; i++) {
      var active = i === index;
      dots[i].classList.toggle('vr-is-active', active);
      if (active) {
        dots[i].setAttribute('aria-current', 'true');
      } else {
        dots[i].removeAttribute('aria-current');
      }
    }

    if (current) current.textContent = pad(index + 1);

    // Sub-pixel scroll positions mean an exact equality test misses the ends,
    // so allow a pixel of slack before disabling an arrow.
    if (prev) prev.disabled = viewport.scrollLeft <= 1;
    if (next) {
      var max = viewport.scrollWidth - viewport.clientWidth;
      next.disabled = viewport.scrollLeft >= max - 1;
    }
  }

  function scrollToIndex(i) {
    var clamped = Math.max(0, Math.min(i, slides.length - 1));
    var target = slides[clamped].offsetLeft - viewport.offsetLeft;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    viewport.scrollTo({ left: target, behavior: reduced ? 'auto' : 'smooth' });
  }

  var ticking = false;
  viewport.addEventListener(
    'scroll',
    function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        index = nearestIndex();
        render();
        ticking = false;
      });
    },
    { passive: true }
  );

  dots.forEach(function (dot, i) {
    dot.addEventListener('click', function () {
      scrollToIndex(i);
    });
  });

  if (prev) {
    prev.addEventListener('click', function () {
      scrollToIndex(index - 1);
    });
  }

  if (next) {
    next.addEventListener('click', function () {
      scrollToIndex(index + 1);
    });
  }

  window.addEventListener('resize', render);
  render();
})();
